module.exports = __webpack_public_path__ + "img/icon_success@2x.9cec1d5a.png";